import type { FC, PropsWithChildren } from 'react';
import { createContext, useContext, useMemo } from 'react';

import type { IUser } from 'store/declare';

import { useActiveUser } from './hooks/useActiveUser';

interface IContext {
    /** Текущий активный пользователь */
    activeUser: IUser | null;
}

const Context = createContext<IContext>({ activeUser: null });

export const useMainScreenPartContext = () => useContext(Context);

/** Контекст для работы с центральной частью приложения */
const MainScreenPartContext: FC<PropsWithChildren> = ({ children }) => {
    const activeUser = useActiveUser();

    const contextValue = useMemo<IContext>(() => ({ activeUser }), [activeUser]);

    return <Context.Provider value={contextValue}>{children}</Context.Provider>;
};

export default MainScreenPartContext;
